import { BaseService } from "@flint/framework";

export default class EPubSyncAllData extends BaseService {
  constructor() {
    super("SYNC_ALL_EPUB_DATA","EPubSyncAllResStore",true);
  }

  handleEvent(eventName) {
    // console.log("handleAllSync");
    return this.getClient("vetService").post(`/admin-api/epubs/cloud-search`);
  }
}
